import { render, staticRenderFns } from "./SendMailInformation.vue?vue&type=template&id=653eef2e&scoped=true"
import script from "./SendMailInformation.vue?vue&type=script&lang=js"
export * from "./SendMailInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653eef2e",
  null
  
)

export default component.exports